var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 0v8.37L1.858 4.836.363 6.164 6 12.504l5.636-6.34-1.496-1.328L7 8.37V0zM0 16h12v-2H0z"
  }))));
}
export default SvgFtDownload;